<h3 mat-dialog-title>Escolha o(s) ativo(s)</h3>

<div mat-dialog-content>
    
    <div fxLayout="row wrap">

        <form [formGroup]="boletaForm">

            <div formArrayName="ativos">

                <div 
                    fxLayout="row" 
                    fxLayoutAlign="space-between" 
                    *ngFor="let item of ativos.controls; let pointIndex=index" 
                    [formGroupName]="pointIndex"
                >
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="90">
                        <mat-label>Ativo</mat-label>
                        <input
                            matInput
                            placeholder="Ticker do ativo"
                            aria-label="Ativo"
                            formControlName="ativo"
                            name="ativo"
                            required
                            minlength="5"
                            style="text-transform: uppercase"
                        >
                    </mat-form-field>

                    <button 
                        fxFlex="3"
                        mat-icon-button  
                        tabindex="2" 
                        (click)="removeAtivo(pointIndex)"
                        color="warn"
                        style="height: 65px;"
                    > 
                        <mat-icon aria-label="Adicionar Novo Ativo">remove_circle_outline</mat-icon>                       
                    </button>    
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between" >
                <button 
                    mat-raised-button 
                    color="primary" 
                    (click)="addAtivo()"
                    fxFlex="100"                        
                    style="height: 60px; margin-top: 3px;"
                >
                    <mat-icon aria-label="Adicionar Ativo">add_circle_outline</mat-icon>
                    Adicionar Ativo
                </button>
            </div>           
        </form>
    </div>
</div>

<div mat-dialog-actions>
    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()"
    >
        Cancelar
    </button>
    
    <button 
        mat-button         
        (click)="salvar()" 
        tabindex="-1"
    >
        Gerar Ordens
    </button>
</div>